const messages = {
  message: {
    name: 'Nome',
    surName: 'Apelido',
    mobile: 'Número de telemóvel',
    email: 'Email',
    company: 'Empresa',
    cif: 'NIF',
    profile: 'Perfil da empresa',
    phone: 'Telefone',
    country: 'País',
    location: 'Região',
    address: 'Morada',
    city: 'Cidade',
    cp: 'CP',
    web: 'Website',
    comment: 'Observações',
    terms: {
      wp: 'Li e Aceito a <a href="/politica-privacidad">Politica de Privacidade </a> e as <a href="http://myzone.airzone.es/condiciones-uso"> condições de uso</a>.',
      myzone: 'Li e Aceito a <a href="/politica-privacidad">Politica de Privacidade </a> e as <a href="http://myzone.airzone.es/condiciones-uso"> condições de uso</a>.',
    },
    infoComercial: 'Quero receber informação comercial da Airzone Clima SL',
    formsError: {
      terms: 'Tem de aceitar os termos e as condições de uso.',
      front: 'Não foi possível realizar o envio do formulário devido aos seguintes erros.',
      server: 'Não foi possível realizar o envio deve tentar mais tarde.',
    },
    formsSuccess: {
      AirzoneSIM: 'Registou-se corretamente e em breve irá receber um email com a ferramenta necessária.',
      Myzone: 'O seu pedido foi registado e será processado o mais rápido possível.',
    },
    personalData: 'Seus dados pesssoais',
    companyData: 'Seus dados profissionais',
    submit: 'Enviar',
    selectSim: {
      label: '¿Como conoció Airzone SIM?',
      options: {
        'Técnico/Comercial/Prescriptor': 'Técnico / Comercial / Prescriptor',
        'Distribuidor/Oficial/ATD': 'Distribuidor / Oficial / ATD',
        'Promotora/Constructora': 'Promotora / Constructora',
        'Arquitecto/Ingeniería': 'Arquitecto / Ingeniería',
        Instalador: 'Instalador',
        'RRSS/Medios': 'Redes sociales / Medios',
        'Cursos-Formacion': 'Cursos de Formación',
      },
    },
  },
};

export default messages;
